import React from "react";
import { Link, withRouter } from "react-router-dom";

import "./components.css";

function Navigation(props) {
  const tokenString = sessionStorage.getItem("token");
  const userToken = JSON.parse(tokenString);
  const Username = userToken.username;
  //const UserID = userToken.userId;

  const logout = () => {
    sessionStorage.removeItem("token");
    window.location.reload(true);
  };

  return (
    <div className="navigation">
      <nav className="navbar navbar-expand navbar-dark grid-bg-colour">
        <div className="container">
          <Link className="navbar-brand" to="/">
            {Username} - WMS Portal
          </Link>

          <div>
            <ul className="navbar-nav ml-auto">
              <li
                className={`nav-item  ${
                  props.location.pathname === `${"/" || "/stock"}`
                    ? "active"
                    : ""
                }`}
              >
                <Link className="nav-link" to="/">
                  Stock
                  <span className="sr-only">(current)</span>
                </Link>
              </li>

              <li
                className={`nav-item  ${
                  props.location.pathname === "/movements" ? "active" : ""
                }`}
              >
                <Link className="nav-link" to="/movements">
                  Movements
                  <span className="sr-only">(current)</span>
                </Link>
              </li>

              <li
                className={`nav-item  ${
                  props.location.pathname === "/count" ? "active" : ""
                }`}
              >
                <Link className="nav-link" to="/count">
                  Count
                  <span className="sr-only">(current)</span>
                </Link>
              </li>

              <li
                className={`nav-item  ${
                  props.location.pathname === "/shiplists" ? "active" : ""
                }`}
              >
                <Link className="nav-link" to="/shiplists">
                  Shiplists
                  <span className="sr-only">(current)</span>
                </Link>
              </li>

              <li>
                <div className="spacer"></div>
              </li>
              <li
                className={`nav-item  ${
                  props.location.pathname === "/Login" ? "active" : ""
                }`}
              >
                <Link className="nav-link" to="/" onClick={logout}>
                  Sign Out
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default withRouter(Navigation);
